import { Box, Button, chakra, Flex, Image, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { ButtonVariant } from 'presentation/theme/components/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import sharesproMark from 'assets/img/logos/sharespro-mark-green.svg';

const GeneralSurveyCard: FC = (props) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <>
      <AppCard
        minH="130px"
        p="15px"
        display="flex"
        justifyContent="space-between"
        bgImage="linear-gradient(180deg, #848484 0%, #323232 100%)"
        bgColor={Color.Primary500}
        {...props}
      >
        <Flex flexDirection="column" justifyContent="space-between">
          <Box>
            <Text mb="10px" color="white" fontSize="18px" fontWeight={700}>
              {t('improveAppFeedbackTitle')}
            </Text>
            <Text maxW="240px" mb="24px" color="white">
              {t('improveAppFeedbackText')}
            </Text>
          </Box>
          <Flex>
            <Button
              variant={ButtonVariant.Light}
              onClick={() => navigate(AppRoute.generalSurvey)}
            >
              {t('improveAppFeedbackFillForm')}
            </Button>
          </Flex>
        </Flex>
        <Image src={sharesproMark} h="100px" w="100px" objectFit="contain" />
      </AppCard>
    </>
  );
};

export default chakra(GeneralSurveyCard);
